import React, { FC, useCallback, useEffect } from 'react';
import { Card, Container } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import PageTitle from '../../components/layout/pageTitle/PageTitle';
import useNotificationList from '../../hooks/api/notification/useNotificationList';
import Header from '../../components/layout/header/Header';
import { getOrganizationId } from '../../utilities/LocalStorage';
import OrganizationInvitationNotification from './components/OrganizationInvitationNotification';
import useReadNotifications from '../../hooks/api/notification/useReadNotifications';
import useUnreadNotificationCount from '../../hooks/api/notification/useUnreadNotificationCount';
import EmptyList from '../../components/layout/emptyList/EmptyList';
import { RouteType } from '../../routes/routes';

interface Props {
  route: RouteType;
}

const NotificationType = {
  ORGANIZATIONINVITATION: OrganizationInvitationNotification,
};

const NotificationsPage: FC<Props> = ({ route }) => {
  const intl = useIntl();
  const { notifications, getNotificationsByPage } = useNotificationList();
  const { readNotifications } = useReadNotifications();
  const organization = getOrganizationId();
  const { getUnreadNotificationCount } = useUnreadNotificationCount();

  const refreshNotifications = useCallback(() => {
    getNotificationsByPage(1);
  }, []);

  useEffect(() => {
    const notificationsIds = notifications.filter((n) => !n.isRead).map((n) => n.id);
    if (notificationsIds && notificationsIds.length > 0) {
      readNotifications(notificationsIds).then(getUnreadNotificationCount);
    }
  }, [notifications]);

  return (
    <React.Fragment>
      {!organization && <Header></Header>}
      <div className="d-flex justify-content-center">
        <div className="page-content notifications-page">
          <Container fluid>
            <PageTitle
              showOrganization={false}
              title={intl.formatMessage({ id: 'navbar.settings.notifications.title' })}
              backRoute={route}
            ></PageTitle>
            {notifications.length === 0 && (
              <Card>
                <Card.Body>
                  <EmptyList message={intl.formatMessage({ id: 'notificationList.empty' })} />
                </Card.Body>
              </Card>
            )}
            {notifications.map((notification) => {
              const NotificationComponent = NotificationType[notification.type];
              return (
                <Card key={notification.id}>
                  <Card.Body className="py-4">
                    <NotificationComponent
                      organization={notification.content.organization}
                      invitedBy={notification.content.invitedBy}
                      notification={notification}
                      refresh={refreshNotifications}
                    ></NotificationComponent>
                  </Card.Body>
                </Card>
              );
            })}
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NotificationsPage;
